module.exports = __webpack_public_path__ + "img/html-evolution-9.4c16b000.jpg";